import { Status } from '../status/status';
import { AttachmentData, Attachment, AttachmentSource } from '../attachment/attachment';
import { MmModel } from '@docma-mm-core/model/mm.model';
import { MmSyncableModel } from '@docma-mm-core/model/mm-syncable.model';
import { LoadState } from '@docma-mm-core/model/load-state/load-state';
import { LoadStatusEnum } from '@docma-mm-core/model/load-state/load-state.enum';
import { ChangeStatusEnum } from '@docma-mm-core/model/change-state/change-status.enum';
import { ChangeState } from '@docma-mm-core/model/change-state/change-state';
import { User } from '@docma-mm-core/user/user';
import { BehaviorSubject } from 'rxjs';
import { GroupData } from '@docma-mm-core/group/group';
import { Fault } from '@docma-mm-core/fault/fault';
import {FaultData} from '@docma-mm-core/fault/fault-data';


export class ActivityData {
  /**
   *
   */
  constructor(init?: Partial<ActivityData>) {
    if (init) {
      Object.assign(this, init);
      if (this.Files) {
          this.Files = init.Files.map(a=> new AttachmentData(a));
      }
      if (this.Date) {
        this.Date = new Date(this.Date);
      }
      if (this.DueDate) {
        this.DueDate = new Date(this.DueDate);
      }
      if (this.ReplyUntil) {
        this.ReplyUntil = new Date(this.ReplyUntil);
      }
      if (this.CreatedOn) {
        this.CreatedOn = new Date(this.CreatedOn);
      }
      if (this.ModifiedOn) {
        this.ModifiedOn = new Date(this.ModifiedOn);
      }
    }
  }
  Fault?: FaultData;
  Id?: number;
  UniqueId?: string;
  FaultId?: number;
  Status?: Status;
  Description?: string;
  Date?: Date;
  DueDate?: Date;
  ReplyUntil?: Date;
  SyncId?: string;
  IsFirst?: boolean;
  IsLast?: boolean;
  IsLastOfViewPoint?: boolean;
  ViewPoint?: number;
  SUid?: string;
  Files?: AttachmentData[];
  Creator?: User;
  Modifier?: User;
  CreatedOn?: Date;
  ModifiedOn?: Date;
  FaultsCount?: number;
  Email?: EmailData;
  Group?: GroupData;

  static compare(a: ActivityData, b: ActivityData): ActivityData {
    const patch = new ActivityData();
    Object.keys(b).forEach(k => {
      switch (k) {
        case 'Status':
          if ( a.Status.Id !== b.Status.Id ) {
            patch.Status = new Status({Id: b.Id});
          }
          break;
        case 'Files':
          break;
        default:
          if (b[k] !== a[k]) {
            patch[k] = b[k];
          }
          break;
      }
    });
    return patch;
  }

}

export class Activity extends MmSyncableModel<ActivityData> {

  private _attachments = new BehaviorSubject<Array<Attachment>>([]);
  public attachments$ = this._attachments.asObservable();

  public fault: { id?: number, uid?: string };
  public group: { id?: number, uid?: string };

  constructor(init?: Partial<Activity>) {
    super(init);
    if (init) {
      if (init.fault) {
        this.fault = init.fault;
      }
      if (init.attachments && init.attachments.length > 0) {
        this.attachments = init.attachments.map(a => new Attachment(a));
      }
    }
    if (!this.attachments) {
      this.attachments = [];
    } else {

    }
  }

  get attachments(): Attachment[] {
    return this._attachments.value;
  }
  set attachments(v: Attachment[]) {
    this._attachments.next(v);
  }

  get isNew(): boolean {
    return !this.id;
  }


  addAttachment(attachment: Attachment) {

    if (!this.attachments || this.attachments.length === 0 || !this.attachments.find(a => a.uid === attachment.uid)) {
      const newArray = [...this.attachments || []];
      attachment.activity = {id: this.id, uid: this.uid};
      attachment.fault = this.fault;
      newArray.push(attachment);
      this.attachments = newArray;
    }
  }
}


export class EmailData {
  IsSent?: boolean;
  To?: string;
  MessageGuid?: string;
}
